import React from 'react'
import { GlobeIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'

export default function GlobalPcBadge() {
	const { t } = useTranslation()

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<GlobeIcon className='size-4 shrink-0 text-muted-foreground' />
			</TooltipTrigger>
			<TooltipContent>
				{t('global_pc.hint', {
					defaultValue: 'Global pricing campaign: impacts various OGs',
				})}
			</TooltipContent>
		</Tooltip>
	)
}
